export { default } from '#/containers/Home'
export { getServerSideProps } from '#/containers/Home/redirect'
